const ITEMS = [
  "Sanepid",
  "PIP",
  "RODO",
  "Regulamin rezerwacji",
  "Umowy pracownicze",
  "Monitoring",
  "Klauzula no-show",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl italic text-cream/90 sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-brick-soft/70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-choc-deep/40 bg-choc py-5"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
